import axios from '@/libs/axios'
import crudActions from '@/store/crudActions'

const actions = crudActions('settings')
const myOrganization = ({ commit }) => new Promise((resolve, reject) => {
  axios.get('organizations/organization_me')
    .then(response => {
      commit('SET_MY_ORGANIZATION', response.data)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const myOrganizationPatch = (ctx, data) => new Promise((resolve, reject) => {
  axios.patch(`organizations/${data.id}/`, data)
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      reject(error)
    })
})
export default {
  ...actions,
  myOrganization,
  myOrganizationPatch,
}
